import { type IAdvancedRichText } from '@framework/engine/inputs/rich-text-advanced/IAdvancedRichText.ts';
import { type IReference } from '@framework/engine/schema/expressions/references/IReference.ts';
import { type IBaseWidget } from '@framework/engine/schema/widgets/IBaseWidget.ts';
import { type IInputWidget } from '@framework/engine/schema/widgets/repository/inputs/IInputWidget.ts';
import {
  type IBaseLayoutOptions,
  type WidgetType,
} from '@framework/engine/schema/widgets/Widget.ts';

export enum UploadWidgetKind {
  Button = 'button',
  DragArea = 'dragarea',
}
export enum UploadButtonsLayout {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}
export interface IUploadWidgetLayout extends IBaseLayoutOptions {
  /** Nascondi etichetta */
  hideLabel?: boolean;
  /** Layout dei pulsanti se visualizzati doppi per omissis */
  buttonLayout?: UploadButtonsLayout;
}

export const WidgetUploadType = 'upload' as WidgetType;

/**
 * Input Upload
 */
export interface IUploadWidget extends IInputWidget {
  type: typeof WidgetUploadType;
  kind: UploadWidgetKind;
  /** Titolo pulsante o DragArea */
  title?: IAdvancedRichText;
  /** Titolo pulsante/DragArea versione pubblica */
  publicUploadTitle?: IAdvancedRichText;
  /** Help text per l'area di upload della versione pubblica */
  publicHelpText?: IAdvancedRichText;
  /** Label del campo di input della versone pubblica */
  publicUploadLabel?: IAdvancedRichText;

  layout?: IUploadWidgetLayout;

  /**
   * Permette di specificare una reference come valore di default dell'input.
   */
  defaultValueReference?: IReference | null;

  isAgidAttachment?: boolean | null;
  agidAttachment?: {
    code?: string | null;
    version?: string | null;
  } | null;
}

export function isUploadWidget(widget: IBaseWidget): widget is IUploadWidget {
  return widget.type === WidgetUploadType;
}
